var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.25 13.1172V19.1172C17.25 19.6476 17.0481 20.1563 16.6886 20.5314C16.3292 20.9065 15.8417 21.1172 15.3333 21.1172H4.79167C4.28334 21.1172 3.79582 20.9065 3.43638 20.5314C3.07693 20.1563 2.875 19.6476 2.875 19.1172V8.11719C2.875 7.58675 3.07693 7.07805 3.43638 6.70297C3.79582 6.3279 4.28334 6.11719 4.79167 6.11719H10.5417",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.375 3.11719H20.125V9.11719",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.58301 14.1172L20.1247 3.11719",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkInactive);
export default __webpack_public_path__ + "static/media/external-link-inactive.697d1e27e2e3289f2dc77545730acf94.svg";
export { ForwardRef as ReactComponent };